import { useState } from 'react';

function BasicOfTechnicalAnalysisModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Technical Analysis",
      content: [
        "What is Technical Analysis?",
        "Definition and purpose of technical analysis in stock trading.",
        "How technical analysis helps predict future price movements based on historical data.",
        "Difference between technical and fundamental analysis."
      ]
    },
    {
      title: "Module 2: Key Concepts in Technical Analysis",
      content: [
        "Understanding Price Action",
        "How price movements reflect market sentiment and investor behavior.",
        "Importance of Open, High, Low, and Close (OHLC) in chart analysis.",
        "The concept of trends: Uptrend, Downtrend, and Sideways."
      ]
    },
    {
      title: "Module 3: Types of Charts Used in Technical Analysis",
      content: [
        "Chart Types Overview",
        "Line Charts: Simple chart representing closing prices.",
        "Bar Charts: Displays open, high, low, and close for each time period.",
        "Candlestick Charts: Most commonly used chart type, with patterns that provide insights into market sentiment."
      ]
    },
    {
      title: "Module 4: Support and Resistance Levels",
      content: [
        "Identifying Key Price Levels",
        "What is Support? The price level where a downtrend can be expected to pause due to a concentration of demand.",
        "What is Resistance? The price level where a trend can reverse due to an increase in selling pressure.",
        "How to identify these levels and their significance in price action."
      ]
    },
    {
      title: "Module 5: Trendlines and Chart Patterns",
      content: [
        "Drawing and Interpreting Trendlines",
        "Understanding Trendlines: How to draw lines that indicate the direction of price movements.",
        "Recognizing Chart Patterns: Common patterns like Head and Shoulders, Triangles, Double Top/Bottom, and their significance."
      ]
    },
    {
      title: "Module 6: Technical Indicators and Oscillators",
      content: [
        "Key Technical Indicators",
        "Moving Averages: Understanding Simple Moving Averages (SMA) and Exponential Moving Averages (EMA) and how they help smooth out price data to identify trends.",
        "Relative Strength Index (RSI): How to use RSI to measure whether a stock is overbought or oversold.",
        "MACD (Moving Average Convergence Divergence): A momentum indicator used to spot changes in the strength, direction, momentum, and duration of a trend."
      ]
    },
    {
      title: "Module 7: Volume Analysis",
      content: [
        "The Importance of Trading Volume",
        "How Volume confirms trends: Volume should rise with price advances and fall with price declines.",
        "Using Volume Oscillators to identify potential buy and sell signals.",
        "Volume spikes and their significance in trend reversals or breakouts."
      ]
    },
    {
      title: "Module 8: Understanding Candlestick Patterns",
      content: [
        "Introduction to Candlestick Patterns",
        "Basics of reading Candlestick Charts: The anatomy of a candlestick (open, close, high, low).",
        "Recognizing common candlestick patterns such as Doji, Engulfing, Hammer, Shooting Star, and their potential market implications."
      ]
    },
    {
      title: "Module 9: Risk Management in Technical Analysis",
      content: [
        "Managing Risk with Technical Tools",
        "How to use Stop-loss orders and Take-profit levels based on technical analysis.",
        "The role of Risk/Reward ratio in trade planning.",
        "Setting appropriate position sizes according to risk tolerance."
      ]
    },
    {
      title: "Module 10: Developing a Trading Strategy",
      content: [
        "Building Your Own Strategy",
        "Combining technical indicators, chart patterns, and market trends to form a trading plan.",
        "Backtesting strategies: How to test your strategy on historical data.",
        "The importance of patience, discipline, and a systematic approach to trading."
      ]
    },
    {
      title: "Module 11: Continuous Learning and Practice",
      content: [
        "Mastering Technical Analysis",
        "The importance of practice in improving technical analysis skills.",
        "Resources for learning and improving technical analysis: books, online courses, and trading platforms.",
        "Staying updated with market trends, news, and continuously refining trading strategies."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Technical Analysis Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BasicOfTechnicalAnalysisModule;
